import { FormControlLabel, Switch, Typography } from '@mui/material';
import Widget from '@/components/common/widget';
import { useTranslations } from '@/i18n/use-translations';
import { useNotifications } from '@/hooks/use-notifications';
import { useGetFlowMediaAgentQuery } from '@/state/queries/playout/use-get-flow-media-agent';
import { usePatchFlowMediaAgentMutation } from '@/state/mutations/playout/use-patch-flow-media-agent';

/** Only for flows entitled to the media agent feature; others play presentations from images only. */
export function MediaAgentSettingsWidget({ flowId, disabled = false }: { flowId: string; disabled?: boolean }) {
  const t = useTranslations();
  const notification = useNotifications();
  const { data } = useGetFlowMediaAgentQuery(flowId);
  const { mutateAsync, isPending } = usePatchFlowMediaAgentMutation(flowId);

  if (!data?.entitled) return null;

  const handleChange = async (enabled: boolean) => {
    try {
      await mutateAsync(enabled);
    } catch {
      notification.notifyError(t('flows.detail.configuration.mediaAgent.saveError'));
    }
  };

  return (
    <Widget title={t('flows.detail.configuration.mediaAgent.title')} titleVariant="h6">
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        {t('flows.detail.configuration.mediaAgent.intro')}
      </Typography>
      <FormControlLabel
        control={
          <Switch
            checked={data.enabled}
            disabled={disabled || isPending}
            onChange={(event) => void handleChange(event.target.checked)}
          />
        }
        label={t('flows.detail.configuration.mediaAgent.switchLabel')}
      />
    </Widget>
  );
}
